module.exports = __webpack_public_path__ + "img/wink.399d522f.png";